import { type ClassroomIdea, classroomIdeas } from "@/components/educators/data/classroomIdeas";

function ClassroomIdeaCard({ idea, index }: { idea: ClassroomIdea; index: number }) {
  const mobileTilt = index % 2 === 0 ? "rotate-[-2deg]" : "rotate-[2deg]";

  return (
    <div className={`w-full md:w-[58%] ${idea.cardClassName}`}>
      <article className={`relative w-full ${mobileTilt}`}>
        <img
          src={idea.imageSrc}
          alt={idea.imageAlt}
          aria-hidden={idea.imageAlt ? undefined : true}
          className={idea.imageClassName}
          draggable={false}
        />
        <div className="relative aspect-[420/207] rounded-[1.25rem] bg-surface-lavender border-4 border-black px-3 md:px-5 text-center shadow-sm flex flex-col items-center justify-center">
          <h3 className="charlie-kingdom-font text-brand-purple-deep text-2xl md:text-3xl leading-tight">
            {idea.title}
          </h3>
          <p className="mt-1.5 md:mt-2 text-ink-slate font-semibold text-sm md:text-base leading-snug text-pretty">
            {idea.body}
          </p>
        </div>
      </article>
    </div>
  );
}

export function ClassroomIdeasSection() {
  return (
    <section className="py-16">
      <div className="container mx-auto px-4 max-w-6xl">
        <img
          src="/images/logos/logo-white.svg"
          alt="PlayMath"
          className="mx-auto h-14 md:h-16 w-auto mb-2"
        />
        <h2 className="text-2xl md:text-4xl font-extrabold text-cta-gold text-center">
          in the classroom
        </h2>
        <p className="mt-4 text-center text-white max-w-3xl mx-auto whitespace-pre-line text-balance">
          {
            "Math games change how kids show up to math. When learning feels like play, kids are more willing to take risks, think ahead, and adjust their approach.\n\nHere are four ways to incorporate PlayMath.org into your class!"
          }
        </p>

        <div className="mt-12 md:mt-14 flex flex-col gap-[5.5rem] md:gap-10 max-w-[320px] mx-auto md:max-w-2xl">
          {classroomIdeas.map((idea, index) => (
            <ClassroomIdeaCard key={idea.title} idea={idea} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
